import * as React from 'react';
export const societegeneraleSvg = React.forwardRef(
  function societegeneraleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#000',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0V0Z',
        fill: '#000',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 16V0h32v16',
        fill: '#ED1A3A',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6 14h20v4H6v-4Z',
        fill: '#fff',
      }),
    );
  },
);
societegeneraleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var societegenerale = {
  category: 'brand',
  colorable: false,
  name: 'societegenerale',
  svg: societegeneraleSvg,
};
